var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"projects-page page-padding page-sidebar",class:{'projects-page_full': !_vm.sidebarOpen}},[_c('projects-header'),_c('projects-body'),_c('p',{staticClass:"btn-hint name-hint btn-hint_bottom btn-hint-navigator"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }